<template>
  <v-simple-table style="background-color: #555 !important;">
    <template v-slot:default>
      <!-- 由於無法設置 v-simple-table 的id，從thead設置再來尋找... -->
      <thead :id="`thead-task-working-items-in-task-${task.ID}-in-project-${project.ID}`">
        <tr>
          <th>工作日期</th>
          <th>人員</th>
          <th>工作項目</th>
          <th>分配獎金</th>
          <!-- <th v-show="!isMobile">預估時數</th> -->
          <th v-show="!isMobile">實際時數</th>
          <th>狀態</th>
          <th v-show="!isMobile">簽核</th>
          <th v-show="!isMobile">簽核日期</th>
          <th v-if="!isExporting">操作</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="group in workingItemsGroupByMonth">
          <task-working-item-table-row
            v-for="workingItem in group.items"
            :key="`working-item-${workingItem.ID}`"
            :item="workingItem"
            :is-quick-sign-enabled="isQuickSignEnabled"
            :is-exporting="isExporting"
            @edit="editTaskWorkingItem(workingItem.ID)"
            @remove="deleteTaskWorkingItem(workingItem)"
          />
          <!-- 月總計 -->
          <tr :key="group.month" style="background-color: rgba(0,0,0,0.25);">
            <td></td>
            <td></td>
            <td>{{group.month}}總計:</td>
            <td>{{ group.sumBonus | amountFormat}}</td>
            <!-- <td v-show="!isMobile">
              {{totalExpectedHours}}
            </td> -->
            <td v-show="!isMobile">
              {{group.sumHours}}小時{{group.sumMinutes}}分鐘
            </td>
            <td></td>
            <td v-show="!isMobile"></td>
            <td v-show="!isMobile"></td>
            <td v-if="!isExporting"></td>
          </tr>

        </template>
        <!-- 全總計 -->
        <tr>
          <td></td>
          <td></td>
          <td>總計:</td>
          <td>
            {{totalBonus | amountFormat}}
          </td>
          <!-- <td v-show="!isMobile">
            {{totalExpectedHours}}
          </td> -->
          <td v-show="!isMobile">
            {{totalCostTime}}
          </td>
          <td></td>
          <td v-show="!isMobile"></td>
          <td v-show="!isMobile"></td>
          <td v-if="!isExporting"></td>
        </tr>
      </tbody>

      <task-working-item-addedit-dialog
        v-model="UI.addedit.isShowDialog"
        :editing-id="UI.addedit.id"
      />

    </template>
  </v-simple-table>
</template>

<script>
import { mapGetters } from "vuex";
import TaskWorkingItemTableRow from "./project-dialog-task-working-item-table-row.vue";
import TaskWorkingItemAddeditDialog from "@/ui/project/task/task-working-item-addedit-dialog.vue";
import filterMixin from "@/data/filters/filter-mixin.vue";
export default {
  mixins: [filterMixin],
  components: {
    TaskWorkingItemTableRow,
    TaskWorkingItemAddeditDialog
  },
  props: {
    task: {
      type: Object,
      required: true
    },
    isQuickSignEnabled: {
      type: Boolean,
      defualt: false
    },
    isExporting: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    UI: {
      addedit: {
        isShowDialog: false,
        id: -1
      }
    }
  }),
  computed: {
    project() {
      return this.projectsMap[this.task.ProjectID] || {};
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    workingItems() {
      return this.taskWorkingItems.filter(o => o.TaskID == this.task.ID).sort((o1, o2) => new Date(o1.Date) - new Date(o2.Date));
    },
    workingItemsGroupByMonth() {
      var result = []
      for(let item of this.workingItems) {
        var month = item.Date.substring(0, 7).replaceAll('-', '/')
        var monthItem = result.find(o => o.month == month)
        if (!monthItem) {
          monthItem = {
            month: month,
            items: [],
            sumHours: 0,
            sumMinutes: 0,
            sumBonus: 0
          }
          result.push(monthItem)
        }
        monthItem.items.push(item)
        monthItem.sumHours += item.ActualHours
        monthItem.sumMinutes += item.ActualMinutes
        monthItem.sumBonus += item.Bonus
        while (monthItem.sumMinutes >= 60) {
          monthItem.sumHours += 1
          monthItem.sumMinutes -= 60
        }
      }
      return result
    },
    // totalExpectedHours() {
    //   return this.workingItems.reduce((sum,o) => sum+o.EstimatedHours, 0)
    // },
    totalBonus() {
      return this.workingItems.reduce((sum,o) => sum+o.Bonus, 0)
    },
    totalCostTime() {
      var totalMins = this.workingItems.reduce((sum,o) => sum+o.ActualHours*60+o.ActualMinutes, 0)

      var hours = parseInt(totalMins/60)
      var mins = totalMins%60
      if (mins == 0) return `${hours}小時`
      return `${hours}小時` + `${mins}分鐘`
    },
    ...mapGetters(["taskWorkingItems", "projectsMap"])
  },
  methods: {
    editTaskWorkingItem(itemID) {
      this.UI.addedit.id = itemID;
      this.UI.addedit.isShowDialog = true;
    },
    deleteTaskWorkingItem(item) {
      const removingIdx = this.$store.state.taskWorkingItem.list.indexOf(item);

      this.isLoading = true;
      this.$services.taskWorkingItem
        .delete(this, item.ID)
        .then(res => {
          this.$store.state.taskWorkingItem.list.splice(removingIdx, 1);
          // this.$alertMessage("成功刪除工作" + item.Content + "」!");
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style>
.tableexport-caption {
  display: none;
}
</style>